
// Keep track of whether this machine is the machine that
// is running Orderlah Printer Manager, and Orderlah Printer Manager
// is running normally. Then we can trigger cash drawer directly from API,
// instead of sending request to Orderlah server to be later passed back to

import PrinterManagerHelper from "../app/Merchant/Helper/PrinterManager/PrinterManagerHelper"
import { getAudioSetting } from "../app/Merchant/QueueNumber/Audio/NumberAudioPlayer"
import { PrinterType } from "./Printer"

// Orderlah Printer Manager via websocket connection
let _orderlahPrinterManagerConnected = false

// Timer to periodically check Orderlah Printer Manager conenction
let _timer = null

export const DEFAULT_PRINTER_URL = "http://localhost:3012"
export const PrinterFunctionError = {
    NotImplemented : "Not implemented",
    SkipHealthCheck: "Skip Health Check",
}
export default class PrinterFunction {
    static isLocalPrinterConnected = () => {
        return _orderlahPrinterManagerConnected
    }
    static checkPrinterManagerConnected = () => {
        if (window.debugSetting && window.debugSetting.skip_all_health_check) {
            return
        }
        if (_timer) {
            clearTimeout(_timer)
        }
        if (window.debugSetting.skip_printer_connection_check) {
            return
        }
        if (!window.ipPrinterInfo) {
            return 
        }
        const localPrinterUrl = DEFAULT_PRINTER_URL
        $.ajax({
            url: localPrinterUrl,
            type: "get",
            crossDomain: true,
            success: (response) => {
                if (response === 'Orderlah Printer Manager: OK') {
                    _orderlahPrinterManagerConnected = true
                }
            }
        })
        .fail(xhr => {
            _orderlahPrinterManagerConnected = false
        })

        _timer = setTimeout(PrinterFunction.checkPrinterManagerConnected, 10000)
    }
    static openDrawerByLocalAPI = () => {
        let printerType = null
        const usbPrinterTypes = window.usbPrinterTypes.map(s => s.toLowerCase())
        if (ipPrinterInfo.printer_type && usbPrinterTypes.includes(ipPrinterInfo.printer_type.toLowerCase())) {
            printerType = PrinterType.USB
        }
        $.ajax({
            url: `${DEFAULT_PRINTER_URL}/open_cash_drawer`,
            type: "POST",
            crossDomain: true,
            data : {
                ip_address  : ipPrinterInfo.ip_address,
                port        : ipPrinterInfo.port,
                printer_type: printerType,
            },
            success: (response) => {}
        })
    }
    static openDrawerByServerAPI = () => {
        $.ajax({
            url: "/merchant/api/action/open_drawer",
            type: "POST",
            data : {},
            success: (response) => {
                //Do nothing
            }
        })
    }
    static openDrawer = () => {
        const ipPrinterInfo = window.ipPrinterInfo
        if (ipPrinterInfo && _orderlahPrinterManagerConnected) {
            PrinterFunction.openDrawerByLocalAPI()
        }
        else {
            PrinterFunction.openDrawerByServerAPI()
        }
    }
    static healthCheck = (callback, failCallback) => {

        if (window.debugSetting && (window.debugSetting.skip_all_health_check || window.debugSetting.skip_connectivity_check_loop)) {
            failCallback(PrinterFunctionError.SkipHealthCheck)
            return
        }
        const printerStatus = {
            server_connected: false,
            printers: {
                online: [],
                offline: [],
            },
        }
        let ajaxReq = $.ajax({
            url     : `${DEFAULT_PRINTER_URL}/healthcheck`,
            data    : {},
            success : (res) => {
                if (res.status !== "OK") {
                    callback(printerStatus)
                    return
                }

                const currentAudioSetting = getAudioSetting()
                if (!res.audioSetting || !res.audioSetting.last_saved || res.audioSetting.last_saved < currentAudioSetting.last_saved) {
                    // Audio setting at Printer Manager app is outdated, send the latest setting now
                    PrinterManagerHelper.printerManagerUpdateAudioSetting(currentAudioSetting)
                }
                if (res.websocket_server) {
                    printerStatus.server_connected = res.websocket_server.is_connected
                }
                if (res.printers && res.printers.printers) {
                    res.printers.printers.forEach(printer => {
                        if (printer.alive) {
                            printerStatus.printers.online.push(printer)
                        }
                        else {
                            printerStatus.printers.offline.push(printer)
                        }
                    })
                }
                callback(printerStatus)
            }
        })
        .fail((xhr) => {
            if (xhr.status == 404) {
                // Using older version of Orderlah Printer Manager, < 0.7.2
                // where healthcheck API not implemented yet
                failCallback(PrinterFunctionError.NotImplemented)
                return
            }
            callback(printerStatus)
        })

        return {
            abort: () => {
                ajaxReq.abort()
            }
        }
    }
}